export default {
  title: 'Miten pidit paikasta {{name}}?',
  description: 'Palautteesi on anonyymi ja auttaa meitä kehittymään.',
  upload_google_review: {
    title: 'Arvostele meidät & saat palkinnon',
  },
};
